import _ from "lodash";

const parseElement = (value) => {
  let result = _.attempt(JSON.parse, value);

  if (_.isError(result)) {
    result = [];
  }
  return result;
};

export function successRequest(lhnData) {
  return {
    type: "LHN_REQUEST_SUCCESS",
    payload: lhnData
  };
}
export function successNoResults() {
  return {
    type: "LHN_REQUEST_SUCCESS_NO_RESULTS"
  };
}
export function failRequest(err) {
  return {
    type: "LHN_REQUEST_FAIL",
    payload: err
  };
}

export function successCapiRequest(capiData) {
  return {
    type: "LHN_CAPI_REQUEST_SUCCESS",
    payload: {
      featureToggles: _.has(capiData, "featureToggles")
        ? capiData.featureToggles
        : []
    }
  };
}

export function failCapiRequest(err) {
  return {
    type: "LHN_CAPI_REQUEST_FAIL",
    payload: err
  };
}

export function openSideMenu(openMenuStatus) {
  return {
    type: "LHN_OPEN_SIDE_MENU",
    payload: openMenuStatus
  };
}

export function pendindRequest() {
  return {
    type: "LHN_REQUEST_PENDING",
    payload: null
  };
}

export function changeProfile(user) {
  return {
    type: "CHANGE_PROFILE",
    payload: user
  };
}

export function updateFavoriteTracks(tracks) {
  return {
    type: "UPDATE_FAVORITES_TRACKS",
    payload: tracks
  };
}

export function updateFilters(filterString) {
  let result = {};
  _.attempt(() => {
    result = JSON.parse(filterString);
  });
  return {
    type: "UPDATE_FILTERS",
    payload: result
  };
}

/* this only request greyhounds for now */
export function successCmsRequest(cmsData) {
  return {
    type: "CMS_REQUEST_SUCCESS",
    payload: {
      profiles: _.has(cmsData, "greyhoundsProfiles")
        ? parseElement(cmsData.greyhoundsProfiles).profilesList
        : []
    }
  };
}

export function failCmsRequest(err) {
  return {
    type: "CMS_REQUEST_FAIL",
    payload: err
  };
}

export function toggleDropSide(props) {
  return {
    type: "TOGGLE_DROPSIDE",
    payload: props
  };
}

export function toggleSelectedTrackVideo(data) {
  return {
    type: "TOGGLE_SELECTED_TRACK_VIDEO",
    payload: data
  };
}
